module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/funabashi_concept_02-aa1906810b7eb03b46aab4b9c92d1f1a.jpg";